import layoutsStore from './layoutsStore';
import articleStore from './articleStore';
import musicStore from './musicStore';
import homeStore from './homeStore';
import cvStore from './cvStore';
import aboutStore from './aboutStore';

const stores = {
  layoutsStore,
  articleStore,
  musicStore,
  homeStore,
  cvStore,
  aboutStore,
};

export default stores;